export const ManagerBaseContentTranslations = {
  BASE_CONTENT: {
    es: 'Contenido base',
    en: 'Base content',
    cat: 'Contingut base',
    eus: 'Edukiak base',
    pt: 'Conteúdo base'
  },
  BASE_CONTENT_DESCRIPTION: {
    es: 'Gestiona el contenido central de tus cursos desde un único lugar. Este contenido puede reutilizarse y sincronizarse en otros cursos.',
    en: 'Manage the central content of your courses from a single place. This content can be reused and synchronized in other courses.',
    cat: "Gestiona el contingut central dels teus cursos des d'un sol lloc. Aquest contingut es pot reutilitzar i sincronitzar en altres cursos.",
    eus: 'Edukiak base kudeatu fitxa bakarretan. Edukiak beste ikastarretan erabil daitezke eta sinkronizatu daitezke.',
    pt: 'Gerencie o conteúdo central dos seus cursos de um único lugar. Este conteúdo pode ser reutilizado e sincronizado em outros cursos.'
  },
  SEARCH_BY_NAME: {
    es: 'Buscar por nombre',
    en: 'Search by name',
    cat: 'Cercar per nom',
    eus: 'Izena bilatzeko',
    pt: 'Pesquisar por nome'
  },
  NAME: {
    es: 'Nombre',
    en: 'Name',
    cat: 'Nom',
    eus: 'Izena',
    pt: 'Nome'
  },
  TEACHERS: {
    es: 'Profesores',
    en: 'Teachers',
    cat: 'Professors',
    eus: 'Irakasleak',
    pt: 'Professores'
  },
  COURSE_STATUS: {
    es: 'Estado del curso',
    en: 'Course status',
    cat: 'Estat del curs',
    eus: 'Ikastaro egoera',
    pt: 'Estado do curso'
  },
  LAST_UPDATED: {
    es: 'Última actualización',
    en: 'Last updated',
    cat: 'Última actualització',
    eus: 'Azken eguneraketa',
    pt: 'Última atualização'
  },
  ACTIONS: {
    es: 'Acciones',
    en: 'Actions',
    cat: 'Accions',
    eus: 'Ekintzak',
    pt: 'Ações'
  },
  SEE_BASE_CONTENT: {
    es: 'Ver página del curso',
    en: 'See course page',
    cat: 'Ver pàgina del curs',
    eus: 'Ikastaroaren orrialdea ikusi',
    pt: 'Ver página do curso'
  },
  DELETE: {
    es: 'Eliminar',
    en: 'Delete',
    cat: 'Eliminar',
    eus: 'Ezabatu',
    pt: 'Excluir'
  },
  DELETE_COURSE_CONFIRMATION: {
    es: 'El curso <bold>"{{name}}"</bold> se eliminará de forma permanente.',
    en: 'The course <bold>"{{name}}"</bold> will be permanently deleted.',
    cat: 'El curs <bold>"{{name}}"</bold> es eliminarà de forma permanent.',
    eus: 'Ikastaro hau <bold>"{{name}}"</bold> ezabatu da definitiboki.',
    pt: 'O curso <bold>"{{name}}"</bold> será excluído permanentemente.'
  },
  THIS_ACTION_CANNOT_BE_UNDONE: {
    es: 'Esta acción no se puede deshacer.',
    en: 'This action cannot be undone.',
    cat: 'Aquesta acció no es pot desfer.',
    eus: 'Ezeztatu ezin da.',
    pt: 'Esta ação não pode ser desfeita.'
  },
  BASE_CONTENT_IS_BEING_USED: {
    es: '“<bold>{{name}}</bold>” se está usando como base para otros cursos.',
    en: '“<bold>{{name}}</bold>” is being used as base for other courses.',
    cat: '“<bold>{{name}}</bold>” es utilitzat com a base per altres cursos.',
    eus: '“<bold>{{name}}</bold>” ikastaro base gisa erabiltzen da beste ikastaroetan.',
    pt: '“<bold>{{name}}</bold>” está sendo usado como base para outros cursos.'
  },
  WHEN_DELETING: {
    es: 'Al eliminarlo:',
    en: 'When deleting:',
    cat: 'Quan esborrar:',
    eus: 'Ezabatu ondoren:',
    pt: 'Ao excluir:'
  },
  WHEN_DELETING_1: {
    es: 'El curso se eliminará del contenido base.',
    en: 'The course will be removed from the base content.',
    cat: 'El curs esborrarà del contingut base.',
    eus: 'Ikastaro ezabatu da edukiaren basean.',
    pt: 'O curso será removido do conteúdo base.'
  },
  WHEN_DELETING_2: {
    es: 'Los cursos que dependen de él dejarán de estar sincronizados y pasarán a ser contenido independiente.',
    en: 'The courses that depend on it will no longer be synchronized and will become independent content.',
    cat: 'Els cursos que depenen d´ell deixaran de sincronitzar-se i passaran a ser contingut independent.',
    eus: 'Ikastaroenak ezabatu ondoren sinkronizazioa ez da egingo eta edukia independente bihurtuko da.',
    pt: 'Os cursos que dependem dele deixarão de estar sincronizados e passarão a ser conteúdo independente.'
  },
  DELETE_COURSE_QUESTION: {
    es: '¿Eliminar este curso?',
    en: 'Delete this course?',
    cat: 'Eliminar aquest curs?',
    eus: 'Ikastaro hau ezabatu nahi duzu?',
    pt: 'Excluir este curso?'
  },
  ERROR_CHECKING_USAGE: {
    es: 'Error al verificar si el contenido está en uso. Por favor, inténtalo de nuevo.',
    en: 'Error checking if content is in use. Please try again.',
    cat: 'Error en verificar si el contingut està en ús. Si us plau, torna-ho a provar.',
    eus: 'Errorea edukia erabiltzen ari den begiratzean. Mesedez, saiatu berriro.',
    pt: 'Erro ao verificar se o conteúdo está em uso. Por favor, tente novamente.'
  },
  DESIGN_YOUR_CONTENT: {
    es: 'Diseña tu contenido',
    en: 'Design your content',
    cat: 'Diseña el contingut',
    eus: 'Edukia diseinatu',
    pt: 'Desenhar seu conteúdo'
  },
  DESIGN_YOUR_CONTENT_DESCRIPTION: {
    es: 'Crea cursos “madre”, organiza el contenido en secciones y añade actividades. Estos cursos funcionan como base para que otros cursos puedan importar y sincronizar contenido sin empezar desde cero.',
    en: 'Create parent courses, organize content in sections and add activities. These courses work as base for other courses to import and synchronize content without starting from scratch.',
    cat: 'Crea cursos “madre”, organitza el contingut en seccions i afegeix activitats. Aquests cursos funcionen com a base per a que altres cursos puguin importar i sincronitzar contingut sense començar des de zero.',
    eus: 'Edukiak “madre” sortu, edukiak sekzioetan organizatu eta jarduerak gehitu. Ikastaro horiek beste ikastaroetan edukia inportatu eta sinkronizatu dezakete zeroetik hasi gabe.',
    pt: 'Crie cursos “mães”, organize o conteúdo em seções e adicione atividades. Estes cursos funcionam como base para que outros cursos possam importar e sincronizar conteúdo sem começar do zero.'
  },
  NO_RESULTS_FOUND: {
    es: 'No se han encontrado resultados',
    en: 'No results found',
    cat: "No s'han trobat resultats",
    eus: 'Ez da emaitzarik aurkitu',
    pt: 'Não foram encontrados resultados'
  },
  NO_RESULTS_FOUND_DESCRIPTION: {
    es: 'Puede que quieras probar con otras palabras clave o comprobar si hay errores tipográficos.',
    en: 'You may want to try with other keywords or check for typographical errors.',
    cat: 'Potser vols provar amb altres paraules clau o comprovar si hi ha errors tipogràfics.',
    eus: 'Beste gako-hitzak probatu edo errore tipografikoak egiaztatu.',
    pt: 'Você pode querer tentar com outras palavras-chave ou verificar se há erros tipográficos.'
  },
  CREATED_BY: {
    es: 'Creado por',
    en: 'Created by',
    cat: 'Creat per',
    eus: 'Sortu da',
    pt: 'Criado por'
  }
};
